// Colocated strings for BaseBoxPlotChart (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these fourteen keys resolve here, while
// `t(navigationConfig[].titleKey)` is an APP key that resolves through the root composer by
// design (the stacked bar's contract, PLATFORM.md §6 decision 17).
//
// `showing`/`of`/`items`/`durationDays` are lifted verbatim from issue-analysis's
// `src/locales.js` (all 10 bundles), which its BoxPlot read through the global composer. The
// ten tooltip labels (`sampleSize`, `distribution`, `statistics`, `max`, `q3`, `median`, `q1`,
// `min`, `average`, `stdDev`) were English literals in the old tooltip HTML, so they ship as
// ENGLISH in all 10 files on purpose — the `loaded` policy: untranslated (translation debt),
// but resolving locally, so no warning and no chance of a blank. `vi` (the 11th locale,
// 2026-10-28) shipped with all fourteen translated (`q1`/`q3` stay "Q1"/"Q3").
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
